var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-4 {\r\n        fill: none;\r\n        stroke: #353535;\r\n        stroke-width: 2px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-2, .cls-4 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #353535;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.54173,
    x2: 40,
    y1: 16.4584,
    y2: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.22182,25.48527a11,11,0,1,1,15.55635,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 18,
    r: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M.35137,47.64864a1.19963,1.19963,0,0,1,.01738-1.71356L15.5598,31.73521A.85285.85285,0,0,1,16.76555,32.941L2.06681,47.62928A1.19962,1.19962,0,0,1,.35137,47.64864Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 30,
    cy: 18,
    r: 17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/no_found.739413844de43406d4f6bbf58cc10346.svg";
export { ForwardRef as ReactComponent };